import AdministrationMenu from './AdministrationMenu'

export default AdministrationMenu
